import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EditOrderStatus = ({
  isOpen,
  onClose,
  order,
  language,
  onStatusChange, // 🔥 callback جديد
  onDelete
}) => {
  if (!isOpen || !order) return null;

  const [status, setStatus] = useState(order.order_status);

  useEffect(() => {
    setStatus(order.order_status);
  }, [order]);

  const labels = {
    title: { en: 'Order Details', ar: 'تفاصيل الطلب' },
    status: { en: 'Order Status', ar: 'حالة الطلب' },
    saveStatus: { en: 'Save Status', ar: 'حفظ الحالة' },
    close: { en: 'Close', ar: 'إغلاق' },
    delete: { en: 'Delete', ar: 'حذف' },

    CREATED: { en: 'Created', ar: 'تم الإنشاء' },
    PREPARED: { en: 'Prepared', ar: 'تم التحضير' },
    ON_DELIVERY: { en: 'On Delivery', ar: 'قيد التوصيل' },
    DELIVERED: { en: 'Delivered', ar: 'تم التسليم' },
    COMPLETED: { en: 'Completed', ar: 'مكتمل' },
    CANCELLED: { en: 'Cancelled', ar: 'ملغي' }
  };

  const statusOptions = [
    { value: 1, key: 'CREATED' },
    { value: 2, key: 'PREPARED' },
    { value: 3, key: 'ON_DELIVERY' },
    { value: 4, key: 'DELIVERED' },
    { value: 5, key: 'COMPLETED' },
    { value: 6, key: 'CANCELLED' }
  ];

  const handleSaveStatus = () => {
    if (status !== order.order_status) {
      onStatusChange(order.id, status);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-2xl">

        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-border">
          <h2 className="text-xl font-semibold">
            {labels.title[language]}
          </h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">

          {/* Order ID */}
          <div>
            <p className="text-sm text-text-secondary">Order ID</p>
            <p className="text-xl font-bold">#{order.id}</p>
          </div>

          {/* 🔽 Status Dropdown */}
          <div>
            <label className="block text-sm font-medium mb-2">
              {labels.status[language]}
            </label>
            <select
              value={status}
              onChange={(e) => setStatus(Number(e.target.value))}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background focus:ring-2 focus:ring-primary"
            >
              {statusOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {labels[opt.key][language]}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 px-6 py-4 border-t border-border">
          <Button variant="outline" fullWidth onClick={onClose}>
            {labels.close[language]}
          </Button>

          <Button variant="default" fullWidth onClick={handleSaveStatus}>
            {labels.saveStatus[language]}
          </Button>

          <Button
            variant="destructive"
            fullWidth
            onClick={() => {
              onClose();
              onDelete(order);
            }}
          >
            {labels.delete[language]}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditOrderStatus;
